import React from "react";
export const StepContext = /*#__PURE__*/React.createContext();